module.exports = __webpack_public_path__ + "static/img/Sam-Lalor.c4e46c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sam-Lalor.jpg
// module id = dFaF
// module chunks = 0